
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { SocialSignIn } from "@/components/auth/SocialSignIn";
import { supabase } from "@/lib/supabase";
import { Home } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

const SignIn = () => {
  const { user } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Redirect if user is already logged in
  useEffect(() => {
    if (user) {
      navigate("/feed");
    }
  }, [user, navigate]);

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password
      });

      if (error) throw error;

      toast({
        title: "Success",
        description: "You have successfully signed in!",
      });

      // Redirect to feed after successful sign in
      navigate("/feed");
    } catch (error: any) {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="w-full max-w-md space-y-8 p-8">
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold text-white">Sign In</h2>
          <Link to="/">
            <Button variant="ghost" size="icon" className="text-white hover:text-gray-300">
              <Home className="h-5 w-5" />
            </Button>
          </Link>
        </div>
        <form className="space-y-6" onSubmit={handleSignIn}>
          <div>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button type="submit" className="w-full bg-white text-black hover:bg-gray-100">
            Sign In
          </Button>
        </form>

        <div className="mt-6">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-700" />
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-2 bg-black text-gray-400">Or continue with</span>
            </div>
          </div>

          <div className="mt-6 opacity-50 pointer-events-none">
            <SocialSignIn provider="github" />
          </div>
          <p className="text-center text-sm text-gray-400 italic mt-2">*Temporarily disabled</p>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
